import React, { useMemo } from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';
import { TSidebarButton } from '../NavigationButton/NavigationButton';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { sidebarElementAccess } from '~/view/containers/Sidebar/helpers/sidebar';
import './style.scss';

type TSidebarLink = TSidebarButton & {
  to: string;
  path: string;
};

const NavigationLink: React.FC<TSidebarLink> = observer((props: TSidebarLink): JSX.Element | null => {
  const { iconSize = 22, roles = [], permissions = [], access = true, leftComponent = null, rightComponent = null } = props;

  const name = useMemo(
    () => (props.name ? <p className="sidebar_link-text family-semibold text-size-18">{localeStore.t(props.name)}</p> : null),
    [localeStore.loading, props.name]
  );

  if (!sidebarElementAccess(permissions, roles) || !access) return null;

  return (
    <NavLink
      isActive={(match, location) => {
        return location.pathname.includes(props.path);
      }}
      to={props.to}
      className="sidebar_link py-3"
      activeClassName="active"
      onClick={props.onClick}
    >
      <div className="d-flex flex-grow-1 sidebar_link-content align-items-center">
        {leftComponent}
        {props.icon ? (
          <div className="sidebar_link-icon-wrapper mx-2">
            <Icon name={props.icon} size={iconSize} className={classNames('sidebar_link-icon', props.iconClassName)} />
          </div>
        ) : null}
        {name}
        {rightComponent}
      </div>
    </NavLink>
  );
});

export default NavigationLink;
